import { GoogleLogin } from '@react-oauth/google';
import Api from "../services/api";
import { ToastContainer, toast } from 'react-toastify';
import { getUserInfo } from '../utility';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import React from 'react';

function Login() {
	const navigate = useNavigate();
  	const location = useLocation();
	const { login, isAuthenticated, userInfo } = useAuth();

	const from = location.state?.from || '/';

	// Redirect if already authenticated
	React.useEffect(() => {
		if (isAuthenticated) {
			// Use userInfo from AuthContext instead of reading from storage
			if (userInfo?.studio) {
				navigate(`/organisations/${userInfo.studio}`, { replace: true });
			} else {
				navigate(from, { replace: true });
			}
		}
	}, [isAuthenticated, userInfo, navigate, from]);

	return (
		<>
			<div className="body-login">
				<div className="uf-form-signin">
					<div className="text-center">
						<h1 className="text-white h1">
							BI Global
						</h1>
						<h4 className="text-white h3">Account Login</h4>
					</div>
					<form className="mt-4">
						<div className="input-group uf-input-group input-group-lg mb-3">
							{/*<span className="input-group-text fas fa-user"></span>*/}
							<span className="input-icon fas fa-user"></span>
							<input type="text" className="form-control" placeholder="Username or Email address"/>
						</div>
						<div className="input-group uf-input-group input-group-lg mb-3">
							<span className="input-icon fas fa-lock"></span>
							<input type="password" className="form-control" placeholder="Password"/>
						</div>
						<div className="d-flex mb-3 justify-content-between row-function-acc">
							<div className="form-check">
								<input type="checkbox" className="form-check-input uf-form-check-input" id="exampleCheck1"/>
									<label className="form-check-label text-white" htmlFor="exampleCheck1">Remember Me</label>
							</div>
							<a href=".">Forgot password?</a>
						</div>
						<div className="d-grid mb-4">
							<button type="submit" className="btn uf-btn-primary btn-lg">Login</button>
						</div>
						<div className="d-flex mb-3">
							<div className="dropdown-divider m-auto w-25"></div>
							<small className="text-nowrap text-white text-login-with">Or login with</small>
							<div className="dropdown-divider m-auto w-25"></div>
						</div>
						<div className="uf-social-login d-flex justify-content-center">
							<GoogleLogin
								onSuccess={response => {
									if(response.credential){
										Api.post('api/login',{
										token: response.credential
										}).then(result => {
										if(result?.data?.status === 0){
											// Use AuthContext login function
											login(result.data.data);
											
											// Get user info from the token
											const data = getUserInfo(result.data.data);
											
											// Navigate after successful login
											if (data?.studio) {
												navigate(`/organisations/${data.studio}`, { replace: true });
											} else {
												navigate(from, { replace: true });
											}
										} else {
											toast.error(result.data.messages);
										}
										})
									} else {
										toast.error('Lỗi đăng nhập !!');
									}
								}}
								onError={() => {
									toast.error('Lỗi hệ thống !!');
								}}
								useOneTap
							/>
							<ToastContainer />
							{/*<a href="#" className="uf-social-ic" title="Login with Facebook">*/}
							{/*	<i className="fab fa-facebook-f"></i>*/}
							{/*</a>*/}
							{/*<a href="#" className="uf-social-ic" title="Login with Twitter"><i className="fab fa-twitter"></i></a>*/}
							{/*<a href="#" className="uf-social-ic" title="Login with Google"><i className="fab fa-google"></i></a>*/}
						</div>
						<div className="mt-4 text-center text-sign-up">
							<small className="text-white">Don't have an account? <a href="#" className="text-white">Sign up</a></small>
						</div>
					</form>
				</div>
			</div>
		</>
	);
}

export default Login;